// Generic Global Vars
'use strict';

var windowW = '',
    debounce = '',
    detectIE = '',
    viewport = '',
    indexOf = [].indexOf || function (item) {
        for (var i = 0, l = this.length; i < l; i++) {
            if (i in this && this[i] === item) return i;
        }
        return -1;
    },
    createCookie = '',
    readCookie = '',
    eraseCookie = '',
    replaceCookie = '';

// Window/Browser/Misc
// Viewport function
viewport = function () {
    var a, e;
    e = window;
    a = 'inner';
    if (!(indexOf.call(window, 'innerWidth') >= 0)) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return {
        width: e[a + 'Width'],
        height: e[a + 'Height']
    };
};

// Assign width of window to variable
windowW = viewport().width;

function GetCurrentUserLocation(callback) {
    if (window.current_location != null) {
        callback(window.current_location);
    }

    if (navigator.geolocation && window.location.protocol === "https:") {
        navigator.geolocation.getCurrentPosition(function (position) {
            window.current_location = position.coords.latitude + ',' + position.coords.longitude;
            $.ajaxSetup({
                headers: { 'current-location': window.current_location }
            });            
            callback(window.current_location);
        }, function (err) {            
            callback(null);
        }, { maximumAge: 60000, timeout: 5000, enableHighAccuracy: true });
    } else {
        callback(null);
    }
}

function logout() {
    $.ajax({
        url: "/api/fvmember/logout",
        type: "GET",                
        success: function (data) {
            var loginPath = $("body").data("login-path");
            window.location = loginPath + '?returnUrl='+window.location.pathname + window.location.search;
        }       
    });
}

//http://stackoverflow.com/questions/27928/calculate-distance-between-two-latitude-longitude-points-haversine-formula
function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    var radius = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1); // deg2rad below
    var dLon = deg2rad(lon2 - lon1);
    var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) *
            Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = radius * c; // Distance in km
    return d;
}

function deg2rad(deg) {
    return deg * (Math.PI / 180);
}

function saveUserLocation(bounds) {
    if (bounds != null) {
        localStorage.NorthEastLat = bounds.getNorthEast().lat();
        localStorage.NorthEastLng = bounds.getNorthEast().lng();
        localStorage.SouthWestLat = bounds.getSouthWest().lat();
        localStorage.SouthWestLng = bounds.getSouthWest().lng();
    }    
}

function getUserLocation() {
    if (localStorage.NorthEastLat != null && localStorage.NorthEastLng != null && localStorage.SouthWestLat != null && localStorage.SouthWestLng != null) {
        var bounds = new google.maps.LatLngBounds();

        bounds.extend(new google.maps.LatLng(localStorage.NorthEastLat, localStorage.NorthEastLng));
        bounds.extend(new google.maps.LatLng(localStorage.SouthWestLat, localStorage.SouthWestLng));

        return bounds;
    }
    return null;
}

function resampleImg(canvas, width, height, resize_canvas) {
    var width_source = canvas.width;
    var height_source = canvas.height;
    width = Math.round(width);
    height = Math.round(height);

    var ratio_w = width_source / width;
    var ratio_h = height_source / height;
    var ratio_w_half = Math.ceil(ratio_w / 2);
    var ratio_h_half = Math.ceil(ratio_h / 2);

    var ctx = canvas.getContext("2d");
    var img = ctx.getImageData(0, 0, width_source, height_source);
    var img2 = ctx.createImageData(width, height);
    var data = img.data;
    var data2 = img2.data;

    for (var j = 0; j < height; j++) {
        for (var i = 0; i < width; i++) {
            var x2 = (i + j * width) * 4;
            var weight = 0;
            var weights = 0;
            var weights_alpha = 0;
            var gx_r = 0;
            var gx_g = 0;
            var gx_b = 0;
            var gx_a = 0;
            var center_y = (j + 0.5) * ratio_h;
            var yy_start = Math.floor(j * ratio_h);
            var yy_stop = Math.ceil((j + 1) * ratio_h);
            for (var yy = yy_start; yy < yy_stop; yy++) {
                var dy = Math.abs(center_y - (yy + 0.5)) / ratio_h_half;
                var center_x = (i + 0.5) * ratio_w;
                var w0 = dy * dy; //pre-calc part of w
                var xx_start = Math.floor(i * ratio_w);
                var xx_stop = Math.ceil((i + 1) * ratio_w);
                for (var xx = xx_start; xx < xx_stop; xx++) {
                    var dx = Math.abs(center_x - (xx + 0.5)) / ratio_w_half;
                    var w = Math.sqrt(w0 + dx * dx);
                    if (w >= 1) {
                        //pixel too far
                        continue;
                    }
                    //hermite filter
                    weight = 2 * w * w * w - 3 * w * w + 1;
                    var pos_x = 4 * (xx + yy * width_source);
                    //alpha
                    gx_a += weight * data[pos_x + 3];
                    weights_alpha += weight;
                    //colors
                    if (data[pos_x + 3] < 255)
                        weight = weight * data[pos_x + 3] / 250;
                    gx_r += weight * data[pos_x];
                    gx_g += weight * data[pos_x + 1];
                    gx_b += weight * data[pos_x + 2];
                    weights += weight;
                }
            }
            data2[x2] = gx_r / weights;
            data2[x2 + 1] = gx_g / weights;
            data2[x2 + 2] = gx_b / weights;
            data2[x2 + 3] = gx_a / weights_alpha;
        }
    }
    //clear and resize canvas
    if (resize_canvas === true) {
        canvas.width = width;
        canvas.height = height;
    } else {
        ctx.clearRect(0, 0, width_source, height_source);
    }

    //draw    
    ctx.putImageData(img2, 0, 0);    
}

function loadExternalSvg(placeholderID, url) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url);    
    xhr.overrideMimeType("image/svg+xml");
    xhr.addEventListener('load', function(e) {
        document.getElementById(placeholderID)
            .appendChild(xhr.responseXML.documentElement);    
    });
    xhr.send("");
}
if (window.svgToReplace != null) {
    window.svgToReplace.forEach(function(r) {
        loadExternalSvg(r.containerID, r.url);
    });
}